import { makeAutoObservable } from "mobx";
import { IProductOffer, IOfferType } from ".";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import moment from "moment";

class ProductOfferStore {
  offers: Array<IProductOffer> = [];
  liveOffers: Array<IProductOffer> = [];
  offerTypes: Array<IOfferType> = [];
  editOffer: IProductOffer | null = null;

  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchOffers = () => {
    const url = ApiConfig.REST_URIS.productOffer.allOffers;
    Api.get(url, (res: ApiResponse<IProductOffer[]>) => {
      if (res?.isSuccess && res.data) {
        this.offers = _.sortBy(res.data, ["id"]);
      }
    });
  };

  fetchLiveOffers = () => {
    const url = ApiConfig.REST_URIS.productOffer.liveOffers;
    Api.get(url, (res: ApiResponse<IProductOffer[]>) => {
      if (res?.isSuccess && res.data) {
        this.liveOffers = _.sortBy(res.data, ["id"]);
      }
    });
  };

  setEditOffer = (offer: IProductOffer | null) => {
    this.editOffer = offer;
  };

  saveOffer = (offer: IProductOffer, callback: Function) => {
    offer.startDate = moment(offer.startDate).format();
    offer.endDate = moment(offer.endDate).format();
    if (offer.productOfferId) {
      Api.put(
        ApiConfig.REST_URIS.productOffer.updateProductOffer(
          offer.productOfferId
        ),
        offer,
        (res: ApiResponse<number>) => {
          callback && callback(res);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.productOffer.createProductOffer,
        offer,
        (res: ApiResponse<number>) => {
          callback && callback(res);
        }
      );
    }
  };

  deleteOffer = (id: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.productOffer.deleteProductOffer(id);
    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  receiveNewOffers = (offer: IProductOffer) => {
    const index = this.liveOffers.findIndex(
      (o) => o.productOfferId === offer.productOfferId
    );
    if (index > -1) {
      this.liveOffers.splice(index, 1, offer);
    } else {
      this.liveOffers.unshift(offer);
    }

    this.liveOffers = [...this.liveOffers];
  };
}

export default ProductOfferStore;
